import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearBuffer } from '../../actions/buffer';

const initialState = null as TokenisedAddress | null;

const slice = createSlice({
  name: '$bufferDeliveryAddress',
  initialState,
  reducers: {
    setBufferDeliveryAddress(
      state,
      action: PayloadAction<TokenisedAddress | null>,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(clearBuffer, (state, action) => {
      return initialState;
    });
  },
});

export const { setBufferDeliveryAddress } = slice.actions;
export default slice.reducer;
